<template>
    <Loading v-if="loading" />
    <div
        v-else
        ref="notificationContainer"
        class="notifications-container-xl"
        @scroll="getPaginationData"
    >
        <NoResult v-if="notificationItems.length === 0 && !loading" />

        <div v-else>
            <div
                v-for="(item, index) in notificationItems"
                :key="index"
                class="border-bottom py-3 d-flex justify-content-between"
            >
                <div>
                    <span v-show="!item.read_at" class="notifications-unread-bolt-xl"></span>
                    <span class="fsz-14 primary-color" :class="[item.status === 'read' && 'ms-4']">
                        {{ JSON.parse(item.data).message }}</span
                    >
                </div>

                <div class="fsz-12 third-color">{{ createdStatus(item.created_at) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import notificationsMixins from '../mixins/notifications-mixins';
import NoResult from './NoResult.vue';
import Loading from '@/components/loading/Loading.vue';

export default {
    components: { NoResult },
    mixins: [notificationsMixins],
    computed: {
        ...mapState({
            loading: (state) => state.notificationStore.loading,
        }),
        createdStatus() {
            return (time) => {
                const date = new Date().getTime();
                const notifeTime = new Date(time).getTime();
                const timeDifference = Math.ceil((date - notifeTime) / 60000); //The time difference between the present time and the notification creation time
                if (timeDifference < 60) {
                    return timeDifference <= 1
                        ? `${timeDifference} Min Ago`
                        : `${timeDifference} Mins Ago`;
                }
                //calculate hours
                if (timeDifference < 1440) {
                    return Math.ceil(timeDifference / 60) <= 1
                        ? `${Math.ceil(timeDifference / 60)} Hour Ago`
                        : `${Math.ceil(timeDifference / 60)} Hours Ago`;
                }
                //Calculate Days
                if (timeDifference < 43800) {
                    return Math.ceil(timeDifference / 1440) <= 1
                        ? `${Math.ceil(timeDifference / 1440)} Day Ago`
                        : `${Math.ceil(timeDifference / 1440)} Days Ago`;
                }
                //Calculate Months
                if (timeDifference < 525600) {
                    return Math.ceil(timeDifference / 43800) <= 1
                        ? `${Math.ceil(timeDifference / 43800)} Month Ago`
                        : `${Math.ceil(timeDifference / 43800)} Months Ago`;
                }
                return Math.abs(timeDifference / 525600).toFixed(0)
                    ? `${Math.abs(timeDifference / 525600).toFixed(0)} Year Ago`
                    : `${Math.abs(timeDifference / 525600).toFixed(0)} Years Ago`;
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.notifications {
    &-container-xl {
        @include scrollbarStyle;
        margin-top: 40px;
        max-height: 80vh;
        overflow-y: auto;
        padding-right: 8px;
    }
    &-unread-bolt-xl {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #707ac9;
        margin-right: 16px;
    }
}
</style>
